/*global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('.no-link a').click(function (e) {
    e.preventDefault();
  });
  $('.practice .link').on('mouseenter focus', function () {
    $(this).parent().find('.image__wrapper').addClass('active');
  });

  $('.practice .link').on('mouseleave blur', function () {
    $(this).parent().find('.image__wrapper').removeClass('active');
  });

  $('.testimonials__slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
  });

  $('.video-filter p').on('click', function (e) {
    e.stopPropagation();
    let parent = $(this).parent();
    parent.toggleClass('active');
    parent.find('#video-filter-form').toggleClass('active-dropdown');
  });

  $('#filter-submit').on('click', function () {
    $('.video-filter').removeClass('active');
    $('#video-filter-form').removeClass('active-dropdown');
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.video-filter').length) {
      $('.video-filter').removeClass('active');
      $('#video-filter-form').removeClass('active-dropdown');
    }
  });

  function getCheckedCategories() {
    let categories = [];
    $('input[name="video_category[]"]:checked').each(function () {
      categories.push($(this).val());
    });
    return categories;
  }

  function updateActiveFilters(categories) {
    const $container = $('#active-filters');
    $container.empty();

    if (categories.length === 0) return;

    categories.forEach(function (slug) {
      const label = $('input[value="' + slug + '"]')
        .parent()
        .text()
        .trim();

      const tag = $('<span>')
        .addClass('active-filter-tag')
        .text(label)
        .append($('<span class="tag-x">').text(' ×'))
        .attr('data-slug', slug);

      $container.append(tag);
    });
  }

  function fetchFilteredVideos(categories = []) {
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_videos_ajax',
        categories: categories,
      },
      beforeSend: function () {
        $('.js-video-posts').html('<p>Loading...</p>');
      },
      success: function (response) {
        $('.js-video-posts').html(response);
        updateActiveFilters(categories);
      },
    });
  }

  $('#video-filter-form').on('submit', function (e) {
    e.preventDefault();
    const selected = getCheckedCategories();
    fetchFilteredVideos(selected);
  });

  // "Clear Selection" button
  $('#filter-clear').on('click', function () {
    $('input[name="video_category[]"]').prop('checked', false);
    fetchFilteredVideos([]); // no categories
  });

  // Remove individual active filter tag
  $('#active-filters').on('click', '.active-filter-tag', function () {
    const slug = $(this).data('slug');
    $('input[value="' + slug + '"]').prop('checked', false);
    const updated = getCheckedCategories();
    fetchFilteredVideos(updated);
  });

  // pagination
  function fetchVideos(page = 1) {
    const categories = getCheckedCategories(); // Додано
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_videos_ajax',
        categories: categories,
        page: page,
      },
      beforeSend: function () {
        $('.js-video-posts').html('<p>Loading...</p>');
      },
      success: function (response) {
        $('.js-video-posts').html(response);
        updateActiveFilters(categories);
      },
    });
  }

  $(document).on('click', '.video-pagination a', function (e) {
    e.preventDefault();

    const href = $(this).attr('href');
    let page = 1;

    const pagedParam = href.match(/paged=(\d+)/);
    if (pagedParam) {
      page = parseInt(pagedParam[1]);
    } else {
      const pathMatch = href.match(/\/page\/(\d+)\//);
      if (pathMatch) {
        page = parseInt(pathMatch[1]);
      }
    }

    fetchVideos(page);
  });

  $('.table-of-content .title').on('click', function () {
    $(this).toggleClass('active');
    $('.table-of-content ol').toggleClass('is-active');
  });

  // const stickyElement = document.querySelector('.table-of-content');
  // const sentinel = document.querySelector('.sentinel');
  //
  // const observer = new IntersectionObserver(
  //   ([entry]) => {
  //     if (entry.boundingClientRect.y < 0) {
  //       stickyElement.classList.add('is-stuck'); // Element is stuck
  //     } else {
  //       stickyElement.classList.remove('is-stuck'); // Element is not stuck
  //     }
  //   },
  //   { threshold: [1] }
  // );
  //
  // observer.observe(sentinel);

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 150 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  // search form
  const icon = $('.nav-contact__search-icon');
  const form = $('.header-secrch-form-wrap');
  const searchClose = $('.search-close');

  icon.on('click', function () {
    form.toggleClass('search-active');
  });

  searchClose.on('click', function () {
    form.removeClass('search-active');
  });

  $(document).on('click', function (event) {
    if (
      !$(event.target).closest('.header-secrch-form-wrap').length &&
      !$(event.target).closest('.nav-contact__search-icon').length
    ) {
      $('.header-secrch-form-wrap').removeClass('search-active');
    }
  });

  const arrowDown = document.querySelector('.arrow-down-wrap');

  if (arrowDown) {
    arrowDown.addEventListener('click', function () {
      const currentSection = this.closest('section');

      if (currentSection) {
        const nextSection = currentSection.nextElementSibling;

        if (nextSection) {
          const offset =
            nextSection.getBoundingClientRect().top + window.pageYOffset - 50;

          window.scrollTo({
            top: offset,
            behavior: 'smooth',
          });
        }
      }
    });
  }

  function animateCardsOnce() {
    const cards = document.querySelectorAll(
      '.js-hero-links .slick-slide .home-hero__links-item-wrap'
    );
    cards.forEach((card, index) => {
      card.style.opacity = 0;
      card.style.transform = 'translateX(10px)';
      setTimeout(() => {
        card.style.animation = 'fadeInUp 0.8s forwards';
      }, index * 200);
    });
  }

  $('.hero-section, h1').addClass('animate');
  $('.hero-section, .p-tag').addClass('animate');
  $('.home-hero__title, .home-hero__desq').addClass('animate');

  $('.js-hero-links').on('init', function (event, slick) {
    var lastIndex = slick.$slides.length - 1;
    slick.$slides.eq(lastIndex).addClass('last-slide');
    animateCardsOnce();
  });

  $('.js-hero-links').on('afterChange', function (event, slick) {
    var lastIndex = slick.$slides.length - 1;
    slick.$slides.eq(lastIndex).addClass('last-slide');
    animateCardsOnce();
  });

  $('.js-hero-links').slick({
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  $('.list-wrap__item').on('click', function () {
    $('.list-wrap__item').removeClass('active');
    $(this).addClass('active');
    var postId = $(this).attr('data-post-id');
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'get_team_info',
        post_id: postId,
      },
      success: function (response) {
        $('.team-list__info-wrap').html(response);
      },
      error: function () {
        alert('There was an error!');
      },
    });
  });

  if ($('.info-icon').length) {
    $('.info-icon').on('click', function () {
      let item = $(this).parents('.list-wrap__item');
      let info = item.find('.list-wrap__item-mobile-info');
      info.addClass('active-info');
    });
  }
  if ($('.info-close').length) {
    $('.info-close').on('click', function () {
      let item = $(this).parents('.list-wrap__item-mobile-info');
      item.removeClass('active-info');
    });
  }

  const containers = document.querySelectorAll('.digit-container');
  const homeCases = document.querySelectorAll('.results .digit-container');

  function animationWaterfall(elemnt) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const container = entry.target;
            const digit = parseInt(container.dataset.digit, 10);
            const strip = container.querySelector('.digit-strip');
            const digitHeight = strip.querySelector('.digit').offsetHeight;

            if (!isNaN(digit)) {
              const offset = digit * digitHeight;
              const index = parseInt(container.dataset.index, 10);
              const delay = index * 10;

              requestAnimationFrame(() => {
                setTimeout(() => {
                  strip.style.transition = 'top 2s ease-in-out';
                  strip.style.top = `-${offset}px`;
                }, delay);
              });
            }

            observer.unobserve(container);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    elemnt.forEach((container) => {
      observer.observe(container);
    });
  }

  if (homeCases.length) {
    animationWaterfall(homeCases);
  }

  if (containers.length) {
    animationWaterfall(containers);
  }

  //mobile menu
  $('.drop-down-button').on('click', function () {
    $(this).next().addClass('active-dropdown');
  });

  $('.back-to-main').on('click', function () {
    $(this).parents('.mega-menu-content').removeClass('active-dropdown');
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
document.addEventListener('DOMContentLoaded', function () {
  // Exit early if we're on a single Team CPT page
  if (document.body.classList.contains('single-team')) return;

  const tocList = document.querySelector(
    '.table-of-content__content .content-titles-list'
  );
  if (!tocList) return;

  const postContent = document.querySelector('.post'); // Adjust this selector as needed
  const headings = postContent.querySelectorAll('h2');
  if (!headings.length) return;

  headings.forEach((heading, index) => {
    const id = `section-${index + 1}`;
    heading.id = id;

    const text = heading.querySelector('span')
      ? heading.querySelector('span').textContent
      : heading.textContent;

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = text.trim();

    li.appendChild(a);
    tocList.appendChild(li);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggleButton = document.querySelector('.js-legal-services-toggle');
  const menuWrapper = document.querySelector('.js-legal-services-menu');

  function isMobile() {
    return window.innerWidth <= 1025;
  }

  if (toggleButton && menuWrapper) {
    toggleButton.addEventListener('click', function () {
      if (isMobile()) {
        const isOpen = menuWrapper.style.display === 'block';
        menuWrapper.style.display = isOpen ? 'none' : 'block';
        toggleButton.classList.toggle('active', !isOpen);
      }
    });
  }

  // Optional: Ensure correct state on resize
  // window.addEventListener('resize', function () {
  //   if (!isMobile()) {
  //     menuWrapper.style.display = 'block';
  //   } else {
  //     menuWrapper.style.display = 'none';
  //   }
  // });
});

document.addEventListener('DOMContentLoaded', function () {
  // const tabsContainer = document.querySelector('#bottom-tabs');
  const tabButtons = document.querySelectorAll('#bottom-tabs .tabs-title');
  const nextBtn = document.querySelectorAll('.next-tab');
  const prevBtn = document.querySelectorAll('.prev-tab');

  function switchTab(direction) {
    const activeTab = document.querySelector(
      '#bottom-tabs .tabs-title.is-active'
    );
    const tabsArray = Array.from(tabButtons);
    let currentIndex = tabsArray.indexOf(activeTab);

    let newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

    // Wrap around
    if (newIndex < 0) newIndex = tabsArray.length - 1;
    if (newIndex >= tabsArray.length) newIndex = 0;

    const newTab = tabsArray[newIndex];
    const anchor = newTab.querySelector('a');

    if (anchor) {
      anchor.click(); // trigger Foundation tab change
      scrollTabIntoView(newTab);
    }
  }

  function scrollTabIntoView(tabElement) {
    const container = document.querySelector('.tabs-titles-wrap');
    const containerRect = container.getBoundingClientRect();
    const tabRect = tabElement.getBoundingClientRect();

    if (
      tabRect.left < containerRect.left ||
      tabRect.right > containerRect.right
    ) {
      tabElement.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }

  nextBtn.forEach((btn) =>
    btn.addEventListener('click', () => switchTab('next'))
  );
  prevBtn.forEach((btn) =>
    btn.addEventListener('click', () => switchTab('prev'))
  );

  // Optional: also scroll active tab into view on load
  const initiallyActive = document.querySelector(
    '#bottom-tabs .tabs-title.is-active'
  );
  if (initiallyActive) scrollTabIntoView(initiallyActive);
});
// Scroll handler with offset
document.addEventListener('click', function (e) {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;

  // Ignore if not same-page link or empty hash
  if (anchor.getAttribute('href') === '#') return;

  // Prevent default scroll
  e.preventDefault();

  const headerHeight =
    document.querySelector('.header-main-wrap')?.offsetHeight || 0;
  const targetId = anchor.getAttribute('href').slice(1);
  const targetElement = document.getElementById(targetId);

  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
});
